import React from "react";

const ArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.66667 8H13.3333M13.3333 8L9.33333 4M13.3333 8L9.33333 12" />
    </svg>
  );
};

export default ArrowIcon;
